import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * 대학 로고 이니셜 — 대학명 첫 글자. 탐색 카드·장바구니 등에서 공용으로 쓰는 단일 규칙.
 * 규칙이 바뀌어도(예: 두 글자, 비한글 제거) 이 한 곳만 고치면 전 화면이 일관 적용된다.
 * @param name 대학명(예: '연세대학교')
 * @returns 첫 글자(빈 문자열이면 '')
 */
export function universityInitial(name: string): string {
  return name.charAt(0);
}

/**
 * 한글 조사 선택 — 마지막 글자의 받침 유무로 을/를·은/는·이/가 를 고른다.
 * 대학명처럼 동적 문자열에 조사를 붙일 때 "건국대(을)를" 식 병기를 피하기 위한 공용 규칙.
 * @param word 대상 단어(예: '건국대')
 * @param withBatchim 받침 있을 때 조사(예: '을')
 * @param without 받침 없을 때 조사(예: '를')
 * @returns 단어 + 조사(비한글 끝 글자는 받침 없음으로 처리)
 */
export function josa(word: string, withBatchim: string, without: string): string {
  const code = word.charCodeAt(word.length - 1);
  const hasBatchim = code >= 0xac00 && code <= 0xd7a3 && (code - 0xac00) % 28 !== 0;
  return word + (hasBatchim ? withBatchim : without);
}
